import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "bg-h-primary-50 border py-2" }
const _hoisted_3 = { class: "container mx-auto" }
const _hoisted_4 = { class: "container mx-auto px-5 md:px-3 mt-10" }
const _hoisted_5 = { class: "grid grid-cols-12 items-start gap-3" }
const _hoisted_6 = { class: "col-span-12 md:col-span-3 flex flex-col gap-5 mt-6" }
const _hoisted_7 = { class: "rounded-lg border border-gray-200 overflow-hidden mt-[8px]" }
const _hoisted_8 = { class: "flex flex-col w-100" }
const _hoisted_9 = { class: "flex justify-between items-center w-full" }
const _hoisted_10 = { class: "hover:scale-95 transition-all" }
const _hoisted_11 = { class: "col-span-12 md:col-span-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormInfo = _resolveComponent("FormInfo")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ObjectiveForm = _resolveComponent("ObjectiveForm")!
  const _component_Quiz = _resolveComponent("Quiz")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BreadcrumbComponent, {
          home: _ctx.home,
          items: _ctx.items
        }, null, 8, ["home", "items"])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.add", { pt: "Capítulo", en: "Chapter" })), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (item, i) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  key: i,
                  class: _normalizeClass(`${
                  i == _ctx.active
                    ? 'btn-tab-active'
                    : item.done || !item.off
                    ? 'btn-tab-done'
                    : 'btn-tab-gray'
                }`),
                  disabled: item.off,
                  onClick: ($event: any) => (_ctx.changeTab(item.active))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.title), 1),
                      (item.done)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            name: "hi-solid-check-circle",
                            class: "text-h-success-400"
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isEditPage && !item.done)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            name: "hi-solid-x-circle",
                            class: "text-h-error-400",
                            title: item.info
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "disabled", "onClick"]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_TabView, {
            class: "custom-tabs-objective",
            activeIndex: _ctx.active,
            lazy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  (_ctx.course.id)
                    ? (_openBlock(), _createBlock(_component_FormInfo, {
                        key: 0,
                        onOnNext: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(1))),
                        onOnAllow: _ctx.allowSteps,
                        onOnGetCourseById: _ctx.getCourseById,
                        role: _ctx.user.role,
                        chapter: _ctx.chapter,
                        predecessorId: _ctx.predecessorId
                      }, null, 8, ["onOnAllow", "onOnGetCourseById", "role", "chapter", "predecessorId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  (_ctx.course.id)
                    ? (_openBlock(), _createBlock(_component_ObjectiveForm, {
                        key: 0,
                        objectives: _ctx.objectives,
                        chapter: _ctx.chapter,
                        onOnNext: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(2))),
                        onOnAllow: _ctx.allowSteps,
                        onOnUpdate: _ctx.getCourseById
                      }, null, 8, ["objectives", "chapter", "onOnAllow", "onOnUpdate"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  (_ctx.showQuiz)
                    ? (_openBlock(), _createBlock(_component_Quiz, {
                        key: 0,
                        onOnAllow: _ctx.allowSteps,
                        quizId: _ctx.quizId,
                        data: _ctx.quiz,
                        role: _ctx.user.role,
                        objective: _ctx.chapter,
                        course: _ctx.course,
                        questions: _ctx.questions
                      }, null, 8, ["onOnAllow", "quizId", "data", "role", "objective", "course", "questions"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ])
      ])
    ])
  ]))
}